export enum UserGroup {
  RawMaterialWarehouseAdmin = 'RawMaterialWarehouseAdmin',
  YarnWarehouseImportsViewer = 'YarnWarehouseImportsViewer',
  YarnWarehouseImportsEditor = 'YarnWarehouseImportsEditor',
  YarnWarehouseImportsSupervisor = 'YarnWarehouseImportsSupervisor',
  YarnWarehouseImportsAdmin = 'YarnWarehouseImportsAdmin',
  InventoryTypesViewer = 'InventoryTypesViewer',
  InventoryTypesAdmin = 'InventoryTypesAdmin',
  ItemsInventoryViewer = 'ItemsInventoryViewer',
  ItemsInventoryAdmin = 'ItemsInventoryAdmin',
  RollQCViewer = 'RollQCViewer',
  RollQCEditor = 'RollQCEditor',
  RollQCAdmin = 'RollQCAdmin',
  InternalYarnRequisitionAllViewer = 'InternalYarnRequisitionAllViewer',
  InternalYarnRequisitionKnittingViewer = 'InternalYarnRequisitionKnittingViewer',
  InternalYarnRequisitionWarehouseViewer = 'InternalYarnRequisitionWarehouseViewer',
  InternalYarnRequisitionKnittingEditor = 'InternalYarnRequisitionKnittingEditor',
  InternalYarnRequisitionWarehouseEditor = 'InternalYarnRequisitionWarehouseEditor',
  InternalYarnRequisitionAdmin = 'InternalYarnRequisitionAdmin',
  TransferUnitViewer = 'TransferUnitViewer',
  TransferUnitEditor = 'TransferUnitEditor',
  TransferUnitReceiver = 'TransferUnitReceiver',
  TransferUnitAdmin = 'TransferUnitAdmin',
  SplitLotItemViewer = 'SplitLotItemViewer',
  SplitLotItemAdmin = 'SplitLotItemAdmin',
  MergeLotItemViewer = 'MergeLotItemViewer',
  MergeLotItemAdmin = 'MergeLotItemAdmin',
  InventoryReportingViewer = 'InventoryReportingViewer',
  InventoryReportingAdmin = 'InventoryReportingAdmin',
  InventoryBalanceAdmin = 'InventoryBalanceAdmin',
  InventoryBalanceViewer = 'InventoryBalanceViewer',
  InventoryAdjustmentViewer = 'InventoryAdjustmentViewer',
  InventoryAdjustmentEditor = 'InventoryAdjustmentEditor',
  InventoryAdjustmentAdmin = 'InventoryAdjustmentAdmin',
  SupplyWarehouseViewer = 'SupplyWarehouseViewer',
  SupplyWarehouseAdmin = 'SupplyWarehouseAdmin',
  SupplyWarehouseInternalReturnsAdmin = 'SupplyWarehouseInternalReturnsAdmin',
  SupplyWarehouseProviderReturnAdmin = 'SupplyWarehouseProviderReturnAdmin',
  /** Sees Administrative (confidential) purchase orders and every document made from one (#5942). */
  AdministrativePurchaseOrderAdmin = 'AdministrativePurchaseOrderAdmin',
  DispatchInstructionViewer = 'DispatchInstructionViewer',
  DispatchInstructionCustomerServiceEditor = 'DispatchInstructionCustomerServiceEditor',
  DispatchInstructionExportEditor = 'DispatchInstructionExportEditor',
  DispatchInstructionAdmin = 'DispatchInstructionAdmin',
  DispatchInstructionPriceViewer = 'DispatchInstructionPriceViewer',
  // Status-transition roles (PBI 4569) — not mutually exclusive with each other or with the roles above.
  DispatchInstructionCreationAdmin = 'DispatchInstructionCreationAdmin',
  DispatchInstructionWarehouseAdmin = 'DispatchInstructionWarehouseAdmin',
  DispatchInstructionCompleter = 'DispatchInstructionCompleter',
  FinishedGoodsTransferViewer = 'FinishedGoodsTransferViewer',
  FinishedGoodsTransferEditor = 'FinishedGoodsTransferEditor',
  FinishedGoodsTransferReceiver = 'FinishedGoodsTransferReceiver',
  FinishedGoodsTransferAdmin = 'FinishedGoodsTransferAdmin',
  SecondQualityDispatchViewer = 'SecondQualityDispatchViewer',
  SecondQualityDispatchEditor = 'SecondQualityDispatchEditor',
  SecondQualityDispatchAdmin = 'SecondQualityDispatchAdmin',
  LotItemTransferViewer = 'LotItemTransferViewer',
  LotItemTransferEditor = 'LotItemTransferEditor',
  LotItemTransferReceiver = 'LotItemTransferReceiver',
  LotItemTransferAdmin = 'LotItemTransferAdmin',
  FinishedGoodsRelocationViewer = 'FinishedGoodsRelocationViewer',
  FinishedGoodsRelocationAdmin = 'FinishedGoodsRelocationAdmin',
  RawMaterialRelocationViewer = 'RawMaterialRelocationViewer',
  RawMaterialRelocationAdmin = 'RawMaterialRelocationAdmin',
  LotItemRelocationViewer = 'LotItemRelocationViewer',
  LotItemRelocationAdmin = 'LotItemRelocationAdmin',
  SupplyRequestViewer = 'SupplyRequestViewer',
  SupplyRequestAdmin = 'SupplyRequestAdmin',
  YarnQCViewer = 'YarnQCViewer',
  YarnQCAdmin = 'YarnQCAdmin',
  ReturnSurplusViewer = 'ReturnSurplusViewer',
  ReturnSurplusAdmin = 'ReturnSurplusAdmin',
  ProductionInventoryViewer = 'ProductionInventoryViewer',
  ProductionInventoryAdmin = 'ProductionInventoryAdmin',
  RemissionGuideViewer = 'RemissionGuideViewer',
  RemissionGuideEditor = 'RemissionGuideEditor',
  RemissionGuideAdmin = 'RemissionGuideAdmin',
  InventorySessionViewer = 'InventorySessionViewer',
  InventorySessionEditor = 'InventorySessionEditor',
  InventorySessionAdmin = 'InventorySessionAdmin',
  KardexAuditViewer = 'KardexAuditViewer',
  KardexAuditAdmin = 'KardexAuditAdmin',
  BusinessLotNumbersViewer = 'BusinessLotNumbersViewer',
  BusinessLotNumbersAdmin = 'BusinessLotNumbersAdmin',
  RequisitionViewer = 'RequisitionViewer',
  RequisitionEditor = 'RequisitionEditor',
  RequisitionAdmin = 'RequisitionAdmin',
  GreigeSampleSender = 'GreigeSampleSender',
  GreigeSampleReceiver = 'GreigeSampleReceiver',
  FinishedSampleSender = 'FinishedSampleSender',
  FinishedSampleReceiver = 'FinishedSampleReceiver',
  FinanceCostingAdmin = 'FinanceCostingAdmin',
}
